import * as React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Attendance, Error404, LiveClassroom, LoginPage } from './Features';
import Results from './Features/Results/Results';
import Rules from './Features/Rules-Regulations/Rules.react';
import TimeTable from './Features/TimeTable/TimeTable';
import Performance from './Features/Performance/Performance';
import Home from './Features/HomePage';

import 'tabler-react/dist/Tabler.css';
import MyContextProvider from './context/MyContext';
import Discipline from './Features/Discipline/Discipline';
import Arjuna from './Features/Arjuna/Arjuna';
import './App.css';

import ForgotPassword from './Features/ForgotPassword/forgotpassword';
import Profile from './Features/Profile/Profile';
import { Logout } from './Features/Logout/LogoutRedirect';
import EventDetails from './Features/Events/EventDetails.react';
import BusTracking from './Features/BusTracking/BusTracking';
import { AuthRoute } from './Components/AuthRoute';
import Events from './Features/Events/Events';
import { ParentSiteWrapper } from './Components/ParentSiteWrapper';
import Complaints from './Features/Complaints/Complaints';
import Appointment from './Features/Appointment/Appointment';
import StudentDiary from './Features/StudentDiary/StudentDiary';
import Settings from './Features/Settings/settings.react';
import Noticeboard from './Features/Notice-Board/Notice-Board';
import About from './Features/Settings/settings.about';
import Contact from './Features/Contact/ContactUs.react';
import Notifications from './Features/Notifications/notifications';
import ChangePassword from './Features/ChangePassword/ChangePassword';
import PsAttendance from './Features/PsAttendance/PsAttendance';
import GroupChange from './Features/GroupChange/GroupChange';
// import { Error400 } from './Features';
import { Error401 } from './Features';
import { useAPI } from './ApiCalls/useAPI';
// import { Error403 } from './Features';
// import { Error500 } from './Features';
// import { Error503 } from './Features';

function App() {

    return (
        <React.StrictMode>
            <MyContextProvider>
                <Router basename={'/sanjaya-web'}>
                    <ParentSiteWrapper>
                        <Switch>
                            <Route exact path="/login" component={LoginPage} />
                            <Route
                                exact
                                path="/forgotpassword"
                                component={ForgotPassword}
                            />
                            <Route
                                exact
                                path="/logout_redirect"
                                component={Logout}
                            />
                            <AuthRoute exact path="/" component={Home} />
                            <AuthRoute
                                exact
                                path="/profile"
                                component={Profile}
                            />
                            <AuthRoute
                                exact
                                path="/changePassword"
                                component={ChangePassword}
                            />
                            <AuthRoute
                                exact
                                path="/bustracking"
                                component={BusTracking}
                            />
                            <AuthRoute
                                exact
                                path="/contact"
                                component={Contact}
                            />
                            {/* <AuthRoute
                                exact
                                path="/attendance"
                                component={Attendance}
                            /> */}
                            <AuthRoute
                                path={'/events/:id'}
                                component={EventDetails}
                            />
                            <AuthRoute
                                path="*/notifications"
                                component={Notifications}
                            />
                            <AuthRoute
                                exact
                                path="/liveclassroom"
                                component={LiveClassroom}
                            />
                            <AuthRoute
                                exact
                                path="/complaints"
                                component={Complaints}
                            />
                             <AuthRoute
                                exact
                                path="/appointment"
                                component={Appointment}
                            />
                             <AuthRoute
                                exact
                                path="/studentdiary"
                                component={StudentDiary}
                            />
                            <AuthRoute
                                exact
                                path="/noticeboard"
                                component={Noticeboard}
                            />
                            <AuthRoute
                                exact
                                path="/settings"
                                component={Settings}
                            />
                            <AuthRoute
                                exact
                                path="/settings/about"
                                component={About}
                            />
                            {/* <AuthRoute
                                exact
                                path="/timetable"
                                component={TimeTable}
                            /> */}
                            <AuthRoute
                                exact
                                path="/results"
                                component={Results}
                            />
                            <AuthRoute
                                exact
                                path="/discipline"
                                component={Discipline}
                            />
                            <AuthRoute
                                exact
                                path="/events"
                                component={Events}
                            />
                            <AuthRoute
                                exact
                                path="/arjuna"
                                component={Arjuna}
                            />
                            <AuthRoute exact path="/rules" component={Rules} />
                            <AuthRoute
                                exact
                                path="/performance"
                                component={Performance}
                            />
                            <AuthRoute
                                exact
                                path="/psattendance"
                                component={PsAttendance}
                            />
                            <AuthRoute
                                exact
                                path="/groupchange"
                                component={GroupChange}
                            />

                            <Route exact path="/401" component={Error401} />
                            {/* <Route exact path="/400" component={Error400} />
                            <Route exact path="/403" component={Error403} />
                            <Route exact path="/500" component={Error500} />
                            <Route exact path="/503" component={Error503} /> */}

                            <Route exact path="*" component={Error404} />
                        </Switch>
                    </ParentSiteWrapper>
                </Router>
            </MyContextProvider>
        </React.StrictMode>
    );
}

export default App;
